import React, { useState } from "react";
import {
  ButtonWrapper,
  MintDesc,
  StyledCheckBox,
  StyledTerm,
  TermWrapper,
  MintInfoWrapper,
  StyledTokenAmount,
  TokenExcRate,
  WienerBoxImg,
  WienerBoxImgWrapperDesktop,
  WienerBoxImgWrapperMobile,
  WienerBoxWrapper,
  WienerImg,
  WienerImgWrapper,
  TokenAmountWrapper,
  CounterButtonWrapper,
  CounterButton,
  StyledCounter,
} from "./styled";
import bigBoxFrontSrc from "assets/images/wienerBox/bigBoxFront.png";
import bigBoxBackSrc from "assets/images/wienerBox/bigBoxBack.png";
import smallBoxFrontSrc from "assets/images/wienerBox/smallBoxFront.png";
import smallBoxBackSrc from "assets/images/wienerBox/smallBoxBack.png";

import wienerSrc from "assets/images/wienerBox/wiener.png";

import { MintContentWrapper, StyledTitle } from "components/Shared/styled";
import { SecondaryButton, PrimaryButton, WrongNetwork } from "Element/Button";
import { Flex } from "Element/Flex";

import polygonLogo from "assets/icons/polygon.svg";
import { ReactComponent as AddIcon } from "assets/icons/add.svg";
import { ReactComponent as MinIcon } from "assets/icons/min.svg";
import { AnimatePresence, motion } from "framer-motion";
import { useCheckNetwork } from "hooks/CheckNetwork";
import { useDispatch } from "react-redux";
import { setMintLoading, setMintStatus } from "redux/mint/slice";

import { wienerWeb3, wienerNFT } from "utils/wienerWeb3";

const TokenAmount = ({ amountWiener }: { amountWiener: number }) => {
  return (
    <TokenAmountWrapper>
      <Flex flexDirection="row" alignItems="center">
        <img src={polygonLogo} width={32} height={32} alt="" />
        <StyledTokenAmount>{amountWiener * 0.01} MATIC</StyledTokenAmount>
      </Flex>
      <TokenExcRate>
        ${(amountWiener * 1.58 * 0.01).toFixed(2)} USD
      </TokenExcRate>
    </TokenAmountWrapper>
  );
};

const CounterComp = ({
  name,
  setAmountWiener,
  amountWiener,
}: {
  name?: string;
  setAmountWiener: React.Dispatch<React.SetStateAction<number>>;
  amountWiener: number;
}) => {
  const handleClick = (val: number) => {
    if (val < 0 && amountWiener > 0) return setAmountWiener((prev) => prev - 1);
    if (val > 0 && amountWiener < 20)
      return setAmountWiener((prev) => prev + 1);
  };
  return (
    <CounterButtonWrapper name={name}>
      <CounterButton onClick={() => handleClick(-1)} className="btn-sub">
        <MinIcon />
      </CounterButton>
      <StyledCounter>{amountWiener}</StyledCounter>
      <CounterButton onClick={() => handleClick(1)} className="btn-add">
        <AddIcon />
      </CounterButton>
    </CounterButtonWrapper>
  );
};

const WienerBox = () => {
  const [amountWiener, setAmountWiener] = useState(0);
  const [checked, setChecked] = useState(false);
  const { connected, correctNetwork } = useCheckNetwork();
  const dispatch = useDispatch();

  const handleMint = async () => {
    try {
      const account = await wienerWeb3.eth.getAccounts();

      const mintWei = parseInt(wienerWeb3.utils.toWei("0.01", "ether"));

      dispatch(setMintLoading());
      try {
        await wienerNFT.methods
          .mint(amountWiener)
          .send({ from: account[0], value: mintWei * amountWiener });
        dispatch(setMintStatus(true));
      } catch (err) {
        console.error(err);
        dispatch(setMintStatus(false));
      }
    } catch (err) {
      dispatch(setMintStatus(false));
      console.error(err);
    }
  };

  const handleConnect = () => {
    document.getElementById("connect-button")?.click();
  };
  return (
    <>
      <MintContentWrapper
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{ width: "100%" }}
      >
        <StyledTitle>Mint Your Wiener</StyledTitle>
        <WienerBoxWrapper>
          <WienerBoxImgWrapperDesktop>
            <WienerBoxImg src={bigBoxBackSrc} />
            <WienerBoxImg src={bigBoxFrontSrc} />
            <WienerImgWrapper>
              <AnimatePresence
                initial={false}
                exitBeforeEnter={false}
                onExitComplete={() => null}
              >
                {Array.from(new Array(amountWiener)).map((_, idx) => (
                  <WienerImg
                    as={motion.img}
                    src={wienerSrc}
                    key={"wiener" + idx}
                    initial={{ y: 80 }}
                    animate={{ y: 0 }}
                    exit={{ y: 81 }}
                  />
                ))}
              </AnimatePresence>
            </WienerImgWrapper>
            <MintInfoWrapper>
              <TokenAmount amountWiener={amountWiener} />
              <CounterComp
                amountWiener={amountWiener}
                setAmountWiener={setAmountWiener}
              />
            </MintInfoWrapper>
          </WienerBoxImgWrapperDesktop>

          {/* SHOW ON MOBILE */}
          <WienerBoxImgWrapperMobile>
            <WienerBoxImg src={smallBoxBackSrc} />
            <WienerBoxImg src={smallBoxFrontSrc} />
            <WienerImgWrapper>
              <AnimatePresence
                initial={false}
                exitBeforeEnter={false}
                onExitComplete={() => null}
              >
                {Array.from(new Array(amountWiener)).map((_, idx) => (
                  <WienerImg
                    as={motion.img}
                    src={wienerSrc}
                    key={"wiener-mobile" + idx}
                    initial={{ y: 69 }}
                    animate={{ y: 0 }}
                    exit={{ y: 69 }}
                  />
                ))}
              </AnimatePresence>
            </WienerImgWrapper>
            <MintInfoWrapper>
              <TokenAmount amountWiener={amountWiener} />
            </MintInfoWrapper>
          </WienerBoxImgWrapperMobile>
          <CounterComp
            amountWiener={amountWiener}
            setAmountWiener={setAmountWiener}
            name="mobile"
          />
        </WienerBoxWrapper>
        <MintDesc>
          Mint your wiener with 1 MATIC, you can mint wiener with a maximum
          amount of 20 wiener.
        </MintDesc>
        {/* FOOTER CONTENT */}
      </MintContentWrapper>
      <TermWrapper alignItems="center" onClick={() => setChecked(!checked)}>
        <StyledCheckBox type="checkbox" checked={checked} readOnly />
        <StyledTerm>
          By checking this box, I agree to Terms of Service.
        </StyledTerm>
      </TermWrapper>
      <ButtonWrapper justifyContent="center" alignItems="center">
        <SecondaryButton>GET MORE MATIC</SecondaryButton>
        {correctNetwork.length > 0 ? (
          <WrongNetwork disabled>{correctNetwork}</WrongNetwork>
        ) : !connected ? (
          <PrimaryButton onClick={handleConnect}>
            {window.web3 && window.ethereum
              ? "CONNECT WALLET"
              : "INSTALL METAMASK"}
          </PrimaryButton>
        ) : (
          <PrimaryButton
            onClick={handleMint}
            disabled={amountWiener <= 0 || !checked}
          >
            MINT {amountWiener} SAUSAGE
          </PrimaryButton>
        )}
      </ButtonWrapper>
    </>
  );
};

export default WienerBox;
